export default __webpack_public_path__ + "static/banner-how-to-maximise-savings-a72ad55207c85861f0eaac5dc0db6ae2.jpg";